module.exports = __webpack_public_path__ + "img/云存储2.4db24f41.jpg";